<template>
    <div @click.self="closeModal" class="fixed inset-0 z-50 overflow-auto bg-gray-900 bg-opacity-50 flex justify-center items-center">
        <div @click.stop class="h-fit w-2/5 bg-white flex flex-col items-center justify-between p-3">
            <div class="flex flex-col py-2 h-full w-full gap-2">
                <div>
                    <p class="text-lg font-bold text-gray-700 mb-1 text-center">Add New User</p>
                </div>
                <hr/>

                <form class="max-w-sm mx-auto" @submit.prevent="addUser">
                    <div>
                        <div class="mb-5">
                            <label for="userName" class="block mb-2 text-sm font-medium text-gray-900">User Name</label>
                            <input type="text" id="userName" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="User Name" v-model="userName" required>
                        </div>
                        <div class="mb-5">
                            <label for="pass" class="block mb-2 text-sm font-medium text-gray-900">Password</label>
                            <input type="password" id="pass" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Password" v-model="password" required>
                        </div>
                        <div class="mb-5">
                            <label for="pass" class="block mb-2 text-sm font-medium text-gray-900">User Role</label>
                            <select name="userRole" id="userRole" class="rounded-sm px-2 py-0 w-full bg-slate-100" v-model="userRole">
                                <option value="" disabled selected>Pilih Role</option>
                                <option v-for="role in userRoleData" :key="role.userId" :value="role.roleId">{{ role.userRoleName }}</option>
                            </select>
                        </div>
                    </div>
            
                    <button type="submit" class="text-white focus:ring-4 focus:outline-none font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center bg-blue-600 hover:bg-blue-700 focus:ring-blue-800">Submit</button>
                </form>
            </div>
        </div>        
    </div>
</template>
<script>
export default {
    data() {
        return {
            userName: '',
            password: '',
            userRole: "",
        };
    },
    methods: {
        closeModal(event) {
            if (event.target.classList.contains('bg-gray-900')) {
                // this.$store.dispatch('updateMaterialData', this.localFlagData)
                this.$emit('close');
            }
        },
        addUser() {
            try{
                const userData = {
                    name: this.userName,
                    password: this.password,
                    role_id: parseInt(this.userRole)
                }
                // const listId = this.selectedRow.map(objek => objek.id);
                this.$store.dispatch('createUser', { userData });
                this.$toast.success('User Baru Berhasil Tersimpan', {
                    duration: 2500,
                    position: 'top-right'
                });
            }
            catch(error){
                this.$toast.error(`Gagal Menyimpan User Baru, ${error}`, {
                    duration: 2500,
                    position: 'top-right'
                });
            }
        }
    },
    computed: {
        userRoleData() {
            return this.$store.getters.getUserRole;
        },
    },
    mounted() {
        this.$store.dispatch('fetchUserRole')
    }
}
</script>